import * as React from 'react';
export var NavigationRefs = {
  checkAvailability: React.createRef(),
  tickets: React.createRef(),
  highlights: React.createRef(),
  location: React.createRef(),
  moreInfo: React.createRef(),
  reviews: React.createRef(),
  overview: React.createRef(),
  inclusionsAndExclusions: React.createRef(),
  knowBeforeYouBook: React.createRef(),
  cleanlinessSection: React.createRef(),
  description: React.createRef(),
  faqs: React.createRef()
};
export var TabNavigationBarHelper = function (key) {
  return {
    updateNavigationRefPointerElement: function (refElement) {
      if (key && NavigationRefs[key] && refElement) {
        NavigationRefs[key].current = refElement;
      }
    }
  };
};
export var keyboardFocusProps = function (sectionRef, isEnabled) {
  if (isEnabled === void 0) {
    isEnabled = true;
  }
  if (!sectionRef || !isEnabled) {
    return null;
  }
  return {
    ref: TabNavigationBarHelper(sectionRef).updateNavigationRefPointerElement,
    id: sectionRef,
    tabIndex: -1
  };
};